module.exports = function(){

    /*------------------------------------*\
        header
    \*------------------------------------*/

    var isSidebarCartOpened = function(){


        setTimeout(function(){

            if ($('.html').hasClass('is-open--dropdown') ) {
                $('.html').addClass('is-sidebar-cart-opened');
            } else {
                $('.html').removeClass('is-sidebar-cart-opened');
            }

        }, 500);

    };




    // Toggle the megamenu

    $('.js-megamenu-toggle').click(function(e) {
        e.preventDefault();
        $('.html').toggleClass('is-open--megamenu');
        $('.html').removeClass('is-open--dropdown');
    });

    // Toggle the dropdown

    $('.js-cart-toggle').click(function(e) {

        isSidebarCartOpened();


        $('.html').toggleClass('is-open--dropdown');
        $('.html').removeClass('is-open--megamenu');

        // Touchswipe the dropdown
        $('.js-page-cover').swipe({
            swipeStatus: function(event, phase, direction, distance, duration, fingers) {

                if (phase == 'move' && direction == 'right') {
                     $('.html').removeClass('is-open--dropdown');
                     return false;
                }
            }
        });
        e.preventDefault();
    });

    // Close the megamenu and dropdown on page container click

    $('.js-page-cover').click(function() {
        $('.html').removeClass('is-open--dropdown');
        $('.html').removeClass('is-open--megamenu');

        isSidebarCartOpened();
    });

    // Touchswipe the megamenu on mobile

    $('.js-mobile-toggle').click(function(e) {
        $('.js-page-cover').swipe({
            swipeStatus: function(event, phase, direction, distance, duration, fingers) {

                if (phase == 'move' && direction == 'left') {
                     $('.html').removeClass('is-open--megamenu');
                     return false;
                }
            }
        });
        e.preventDefault();
    });


}; // end of module.exports





// WEBPACK FOOTER //
// ./js-source/blocks/megamenu-dropdown.js